import { render, staticRenderFns } from "./InvestReturnSection.vue?vue&type=template&id=494859fc&scoped=true&"
import script from "./InvestReturnSection.vue?vue&type=script&lang=js&"
export * from "./InvestReturnSection.vue?vue&type=script&lang=js&"
import style0 from "./InvestReturnSection.vue?vue&type=style&index=0&id=494859fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494859fc",
  null
  
)

export default component.exports